// extracted by mini-css-extract-plugin
export default {"container":"PopUp_container__21YLk","header":"PopUp_header__Fc+Qk"};